import { node, string, bool, object } from 'prop-types';

export const experiment = {
    children: node,
    test: string.isRequired,
    abTests: object,
    report: bool,
    enrichedReportData: object,
};

export const visibility = {
    report: bool,
    test: string,
    abTests: object,
    enrichedReportData: object,
};
